module.exports = __webpack_public_path__ + "img/Security.2b61fb43.svg";